import axios from 'axios';

export const client = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? `https://elitland.com/api/` : `http://localhost:8010/proxy`,
});
